module.exports = __webpack_public_path__ + "static/media/13-6.b20f27dd.mp3";